import { render } from "./MarketPriceStatisticsChart.vue?vue&type=template&id=78bbe1e0&ts=true"
import script from "./MarketPriceStatisticsChart.vue?vue&type=script&lang=ts"
export * from "./MarketPriceStatisticsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__